var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valueIsDefined)?_c('div',[(_vm.value.code)?_c('case-status-badge',{attrs:{"status":_vm.value,"label-field":_vm.params.labelField}}):_c('span',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }